import { isDefined } from "@ls/js-utils";
import SummaryType from "state/selections/Constants/SummaryType";
export default class TradeTrackingErrorDefinition {
  static getDefault = () =>
    new TradeTrackingErrorDefinition({
      strategyGroupId: 1042,
      tradeStrategyId: 2381,
      covarianceType: "HISTORICAL",
      tradeTrackingErrorType: "Correlated",
      summary: SummaryType.ABSOLUTE,
    });

  #covarianceType;
  #strategyGroupId;
  #tradeStrategyId;
  #tradeTrackingErrorType;
  #summary;

  constructor(props = {}) {
    const {
      covarianceType,
      strategyGroupId,
      tradeStrategyId,
      tradeTrackingErrorType,
      summary
    } = props;

    this.#covarianceType = covarianceType;
    this.#strategyGroupId = strategyGroupId;
    this.#tradeStrategyId = tradeStrategyId;
    this.#tradeTrackingErrorType = tradeTrackingErrorType;
    this.#summary = summary;
  }

  copy = () => {
    return {
      covarianceType: this.covarianceType,
      strategyGroupId: this.strategyGroupId,
      tradeStrategyId: this.tradeStrategyId,
      tradeTrackingErrorType: this.tradeTrackingErrorType,
      summary: this.summary
    };
  };

  get covarianceType() {
    return this.#covarianceType;
  }

  get strategyGroupId() {
    return this.#strategyGroupId;
  }

  get tradeStrategyId() {
    return this.#tradeStrategyId;
  }

  get tradeTrackingErrorType() {
    return this.#tradeTrackingErrorType;
  }

  get summary() {
    return this.#summary;
  }

  setCovarianceType = (value) =>
    new TradeTrackingErrorDefinition({
      ...this.copy(),
      covarianceType: value,
    });

  setStrategyGroupId = (value) =>
    new TradeTrackingErrorDefinition({
      ...this.copy(),
      strategyGroupId: value,
    });

  setTradeStrategyId = (value) =>
    new TradeTrackingErrorDefinition({
      ...this.copy(),
      tradeStrategyId: value,
    });

  setTradeTrackingErrorType = (value) =>
    new TradeTrackingErrorDefinition({
      ...this.copy(),
      tradeTrackingErrorType: value,
    });

  setSummary = (value) =>
    new TradeTrackingErrorDefinition({
      ...this.copy(),
      summary: value,
    });

  get key() {
    return `tradeTE,${this.#covarianceType},${this.#strategyGroupId},${this.#tradeStrategyId
      },${this.#tradeTrackingErrorType},${this.#summary}`;
  }

  get complete() {
    return (
      isDefined(this.covarianceType) &&
      isDefined(this.tradeStrategyId) &&
      isDefined(this.tradeTrackingErrorType) &&
      isDefined(this.strategyGroupId) &&
      isDefined(this.summary)
    );
  }
}
